import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Target, Zap } from 'lucide-react';
export function Slide2LeadGen() {
  const benchmarks = [{
    metric: 'Lead Conversion Rate',
    result: '16%',
    industry: '~5-8%',
    outperformance: '2-3x higher'
  }, {
    metric: 'Click-to-Capture',
    result: '28%',
    industry: '~10-15%',
    outperformance: '2x higher'
  }, {
    metric: 'Engagement Rate',
    result: '57%',
    industry: '~20%',
    outperformance: '2.85x higher'
  }];
  const impacts = ['12 warm leads ready for immediate sales follow-up', 'Discount activation triggers for existing customers', 'Net-new prospects with documented needs', 'Verified decision-makers to reduce sales friction'];
  return <div className="flex flex-col h-full max-w-[1700px] mx-auto w-full" data-id="element-549">
      <div className="mb-8 border-b border-slate-100 pb-6" data-id="element-550">
        <div className="text-sm font-bold text-snakker-purple uppercase tracking-widest mb-2" data-id="element-551">
          02 / Lead Generation
        </div>
        <h2 className="text-4xl font-display font-bold text-slate-900 mb-2" data-id="element-552">
          Outstanding Results
        </h2>
        <p className="text-xl text-slate-500 max-w-4xl" data-id="element-553">
          Minerva generated leads at 2-3x the typical conversion rate.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 flex-1 items-stretch [&>*]:flex [&>*]:flex-col [&>*]:justify-center" data-id="element-554">
        {/* Benchmarks */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.2
      }} className="bg-white rounded-3xl p-6 border border-slate-100 shadow-sm" data-id="element-555">
          <div className="flex items-center gap-3 mb-4" data-id="element-556">
            <div className="p-2.5 bg-minerva-blue/10 rounded-xl" data-id="element-557">
              <TrendingUp className="w-5 h-5 text-minerva-blue" data-id="element-558" />
            </div>
            <h3 className="text-xl font-bold text-slate-800" data-id="element-559">
              Industry-Leading Metrics
            </h3>
          </div>

          <div className="space-y-3" data-id="element-560">
            {benchmarks.map((b, i) => <div key={i} className="flex flex-col p-3 bg-slate-50 rounded-xl border border-slate-100" data-id="element-561">
                <div className="flex justify-between items-center mb-1" data-id="element-562">
                  <span className="font-bold text-slate-700" data-id="element-563">{b.metric}</span>
                  <span className="text-minerva-blue font-bold bg-minerva-blue/10 px-2.5 py-0.5 rounded-full text-xs" data-id="element-564">
                    {b.outperformance}
                  </span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-565">
                  <span className="text-slate-900 font-bold text-lg" data-id="element-566">
                    {b.result}
                  </span>
                  <span className="text-slate-500" data-id="element-567">
                    Industry Avg: {b.industry}
                  </span>
                </div>
              </div>)}
          </div>
        </motion.div>

        {/* Pipeline Impact */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.4
      }} className="bg-slate-50 rounded-3xl p-6 border border-slate-200 flex flex-col" data-id="element-568">
          <div className="flex items-center gap-3 mb-4" data-id="element-569">
            <div className="p-2.5 bg-emerald-100 rounded-xl" data-id="element-570">
              <Zap className="w-5 h-5 text-emerald-600" data-id="element-571" />
            </div>
            <h3 className="text-xl font-bold text-slate-800" data-id="element-572">
              Immediate Pipeline Impact
            </h3>
          </div>

          <div className="space-y-4 flex-1" data-id="element-573">
            {impacts.map((impact, i) => <div key={i} className="flex items-start gap-3" data-id="element-574">
                <div className="w-5 h-5 rounded-full bg-emerald-500 text-white flex items-center justify-center shrink-0 mt-0.5" data-id="element-575">
                  <Target className="w-3 h-3" data-id="element-576" />
                </div>
                <p className="text-base text-slate-700 font-medium" data-id="element-577">{impact}</p>
              </div>)}
          </div>
        </motion.div>
      </div>
    </div>;
}